import { useState } from "react";

// useForm functional componen
export const useForm = (callback: any, initialState = {}) => {

    const [values, setValues] = useState(initialState);

    // onChange
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValues({ ...values, [event.target.name]: event.target.value });
    };

    const onChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        let file = event.target.files? event.target.files[0] : "notFound";
        setValues({ ...values, [event.target.name]: file });
    };


    // onSubmit
    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        await callback(); // triggering the callback
    };

    // return values
    return {
        onChange,
        onChangeFile,
        onSubmit,
        values,
    };
}